import { useState } from 'react'
import { DropdownList } from '../../../common/dropdown/DropdownList'
import { UseI18n } from '../../../common/hooks/useI18n'
import { InputDropdown } from '../../../common/html/input/InputDropdown'
import { ScrollComponent } from '../../../common/scrollComponent'
import { removeAccents } from '../../../helpers/common'
import { POPUP_FIELDS_KEYS } from '../constants'

export const CountriesSelection = ({
  activeCountry,
  setCountry,
  countriesList,
  isValid,
  setIsValid,
}) => {
  const [inputValue, setInputValue] = useState(activeCountry?.name)
  const [isShowDropdown, setIsShowDropdown] = useState(false)

  const onChooseItem = (value) => {
    setCountry(value)
    setInputValue(value?.name)
    setIsValid((prev) => ({
      ...prev,
      [POPUP_FIELDS_KEYS.COUNTRY]: true,
    }))
    setIsShowDropdown(false)
  }

  const onFocus = () => {
    setIsShowDropdown(true)
    setInputValue('')
  }

  const onClick = () => {
    setIsShowDropdown(true)
  }

  const handleClickOutside = () => {
    setInputValue(activeCountry?.name)
    setIsShowDropdown(false)
  }

  const listDrop = [
    ...countriesList?.filter(
      (item) =>
        !!item?.label &&
        removeAccents(item?.label?.toLowerCase()).includes(
          removeAccents(inputValue?.trim().toLowerCase()),
        ),
    ),
  ]

  return (
    <div>
      <InputDropdown
        type="text"
        containerStyle={{ width: 280, marginLeft: 5, height: 28 }}
        style={{
          paddingLeft: 12,
        }}
        isShowDropdown={isShowDropdown}
        onClickOutsideDropdown={handleClickOutside}
        onClick={onClick}
        value={inputValue || ''}
        onChange={(e) => setInputValue(e.target.value)}
        inputProps={{ noControl: true, onFocus }}
        onFocus={onFocus}
        zIndexDropdown={99}
        isShowIconSelect
        isShowIcon={false}
        dropdownContentStyle={{
          padding: 0,
        }}
        styleIcon={{
          marginRight: 4,
        }}
        isValid={isValid}
        textInvalid={UseI18n('userManagement.valid.country')}
        setIsShowDropdown={setIsShowDropdown}
        onClickIcon={onFocus}
      >
        <ScrollComponent autoHeight autoHeightMax={300}>
          <DropdownList
            activeItem={activeCountry}
            data={!!listDrop.length ? listDrop : []}
            onClickItem={onChooseItem}
          />
        </ScrollComponent>
      </InputDropdown>
    </div>
  )
}
